import React from 'react'

import Box from 'components/OrgNav/OrgNavApp/RoleContainer/Sections/ui/Box'
import LoadingDots from 'components/ui/LoadingDots'

function Placeholder() {
  return (
    <Box>
      <div className="proposal-part-placeholder">
        <LoadingDots lg />
      </div>
    </Box>
  )
}

export default Placeholder
